import React, { Fragment, PureComponent } from 'react';
import { Container } from 'reactstrap';
import Pagebreak from '../Pagebreak';
import { Spacer } from '../Shimmer';
import './ComparisionTable.css';
import GenericTable from './GenericTable';
import Woodwork from './Woodwork';

const roomTypeLabel = {
  SAME_ROOM: 'Common Room',
  NEW_ROOM: 'New Room',
  DELETED_ROOM: 'Deleted Room',
};
class ComparisionTable extends PureComponent {
  // static defaultProps = {
  //   versions: {},
  //   project: {
  //     rooms: {},
  //   },
  // };

  constructor(props) {
    super(props);
    this.generateRoom = this.generateRoom.bind(this);
  }

  generateRoom(room) {
    // to get access to `this`

    const { versions } = this.props;
    if (room.modules && room.modules.diffMap) {
      const {
        modules: { diffMap },
        woodWorks,
        appliances,
        furnitures,
        accessories,
        services,
      } = room;

      // Room content check

      if (
        Object.keys(diffMap).length === 0
        && woodWorks.length === 0
        && appliances.length === 0
        && furnitures.length === 0
        && accessories.length === 0
        && services.length === 0
      ) {
        return null;
      }

      return (
        <Fragment key={room.roomName}>
          <Spacer size={20} />
          <h2 className="capitalize">
            {room.roomName}
            {' '}
(
            {room.roomType}
) -
            {roomTypeLabel[room.type]}
          </h2>
          <Spacer size={10} />
          <Woodwork versions={versions} room={room} />
          <GenericTable versions={versions} room={room} type="accessories" />
          <Spacer size={10} />
          <GenericTable versions={versions} room={room} type="appliances" />
          <Spacer size={10} />
          <GenericTable versions={versions} room={room} type="services" />
          <Spacer size={10} />
          <GenericTable versions={versions} room={room} type="furnitures" />
          <Pagebreak />
        </Fragment>
      );
    }
    return false;
  }

  render() {
    const {
      project: { rooms },
    } = this.props;
    const allRooms = rooms.map(room => this.generateRoom(room));
    return <Container>{allRooms}</Container>;
  }
}

// ComparisionTable.propTypes = {
//   versions: PropTypes.object,
//   project: PropTypes.shape({
//     rooms: PropTypes.object,
//   }),
// };

export default ComparisionTable;



// WEBPACK FOOTER //
// ./src/components/ComparisionTable/index.js